export const applicationConfig = {
  appConfig: [
    {
      name: 'home',
      entitlement: 'default',
      visibility: true,
      datatype: 'json',
      serviceFlag: '',
      callingMethod: 'get',
      templateName: '',
      templateStyleUrl: '',
      service: null,
      genericService: 'N',
      aggregationBucket: [
        {
          container: 'Asset',
          fallback: ''
        },
        {
          container: 'Income',
          fallback: ''
        },
        {
          container: 'Protection',
          fallback: ''
        }
      ],
      sort: 2.0
    },
    {
      name: 'home',
      entitlement: 'Annuity',
      visibility: false,
      datatype: 'json',
      serviceFlag: 'life',
      callingMethod: 'get',
      templateName: './ucd-templates/template-ucd.html',
      service:
        '/api/co/secure/myaccounts/v2/accountsummary?buName=Annuity',
      genericService: 'Y',
      sort: 6.0
    },
    {
      name: 'home',
      entitlement: 'PRUCO',
      visibility: false,
      datatype: 'json',
      callingMethod: 'get',
      templateName: './ucd-templates/template-ucd.html',
      service:
        '/wps/wcm/myconnect/UCD_Content/ma-resources/commandaccounts',
      genericService: 'Y',
      sort: 7.0
    },
    {
      name: 'home',
      entitlement: 'LIFE',
      visibility: false,
      datatype: 'json',
      serviceFlag: 'messages',
      callingMethod: 'get',
      templateName: './ucd-templates/template-ucd.html',
      service: '/api/co/secure/myaccounts/v2/accountsummary?buName=LIFE',
      genericService: 'Y',
      sort: 8.0
    },
    {
      name: 'home',
      entitlement: 'Mutual Funds',
      visibility: false,
      datatype: 'json',
      serviceFlag: 'mutualfunds',
      callingMethod: 'get',
      templateName: './ucd-templates/template-ucd.html',
      service:
        '/api/co/secure/myaccounts/v2/accountsummary?buName=Mutual%20Funds',
      genericService: 'Y',
      sort: 9.0
    }
    /*,
    {
      name: 'home',
      entitlement: 'BYC',
      visibility: false,
      datatype: 'json',
      serviceFlag: 'byc',
      callingMethod: 'get',
      templateName: './ucd-templates/template-generic.html',
      service: '/api/co/secure/myaccounts/v2/accountsummary?buName=BYC',
      genericService: 'Y',
      sort: 5.0
    },
       {
         "name": "home",
         "entitlement": "Retirement",
         "visibility": false,
         "datatype": "json",
         "serviceFlag": "retirement",
         "callingMethod": "get",
         "templateName": "./ucd-templates/template-ucd.html",
         "service": "/api/co/secure/myaccounts/v2/accountsummary?buName=Retirement",
         "genericService": "Y",
       "sort": 7.0
     },
        {
          name: "home",
          entitlement: "SIA",
          visibility: false,
          datatype: "json",
          serviceFlag: "sia",
          callingMethod: "get",
          templateName: "./ucd-templates/template-generic.html",
          service: "/api/co/secure/myaccounts/v2/accountsummary?buName=SIA",
          genericService: "Y",
          sort: 10.0
        }
        {
                "name": "home",
                "entitlement": "AGG",
                "visibility": false,
                "datatype": "html-text",
                "serviceFlag": null,
                "callingMethod": "child",
                "templateName": "./ucd-templates/agg-header.html",
                "service": null,
                "genericService": "N",
                "sort": 10.0
            },
            {
                "name": "home",
                "entitlement": "AGG",
                "visibility": false,
                "datatype": "json",
                "serviceFlag": "agg",
                "callingMethod": "get",
                "templateName": "./ucd-templates/template-agg.html",
                "service": "/api/co/secure/myaccounts/v1/accountsummary?buName=AGG",
                "genericService": "Y",
                "sort": 11.0
            }*/
  ],
  navigation_dev: [
    {
      name: 'AppSettingsNav',
      title: 'AppSettingsNav',
      children: [
        {
          name: 'alerts-01',
          title: 'Alerts',
          shortTitle: 'Alerts',
          url: 'https://www3.qa.coint.prudential.com/my-service-center/alerts',
          altText: 'alerts'
        },
        {
          name: 'accountLinks',
          title: 'accountLinks',
          children: [
            {
              name: 'myAccount',
              title: 'My Profile',
              shortTitle: 'My Profile',
              // url: "/wps/myportal/dashboard/my-profile/",
              url: '/mypru/myprofile#/',
              altText: 'My Profile'
            }
          ]
        },
        {
          name: 'homeurl',
          title: 'homeurl',
          shortTitle: 'homeurl',
          url: '/myaccounts/summary',
          altText: 'login'
        }
      ]
    },
    {
      name: 'PrimaryNav',
      title: 'PrimaryNav',
      isActive: 'true',
      children: [
        {
          name: '01-MyAccounts',
          title: 'MY ACCOUNTS',
          shortTitle: 'MY ACCOUNTS',
          url: '/myaccounts/summary',
          altText: 'MY ACCOUNTS',
          isActive: 'true',
          children: ''
        },
        {
          name: '02-MFL',
          title: 'MY FINANCIAL LIFE',
          shortTitle: 'MY FINANCIAL LIFE',
          url: 'https://www3.qa.coint.prudential.com/mfl',
          altText: 'MY FINANCIAL LIFE',
          isActive: 'false',
          children: ''
        },
        {
          name: 'Service-Center-BU3',
          title: 'MY SERVICE CENTER',
          shortTitle: 'MY SERVICE CENTER',
          url: 'https://www3.qa.coint.prudential.com/my-service-center/',
          altText: 'MyServiceCenter',
          isActive: 'false',
          children: ''
        }
      ]
    },
    {
      name: 'TopNav',
      title: 'TopNav',
      children: [
        {
          name: '01-ContactUs',
          title: 'Help',
          shortTitle: 'Help',
          url: 'https://www3.qa.coint.prudential.com/my-service-center/faqs',
          altText: 'Help',
          isActive: 'true',
          children: ''
        }
      ]
    }
  ],
  navigation_qa: [
    {
      name: 'AppSettingsNav',
      title: 'AppSettingsNav',
      children: [
        {
          name: 'alerts-01',
          title: 'Alerts',
          shortTitle: 'Alerts',
          url: 'https://www3.qa.coint.prudential.com/my-service-center/alerts',
          altText: 'alerts'
        },
        {
          name: 'accountLinks',
          title: 'accountLinks',
          children: [
            {
              name: 'myAccount',
              title: 'My Profile',
              shortTitle: 'My Profile',
              // url: "/wps/myportal/dashboard/my-profile/",
              url: '/mypru/myprofile#/',
              altText: 'My Profile'
            }
          ]
        },
        {
          name: 'homeurl',
          title: 'homeurl',
          shortTitle: 'homeurl',
          url: '/myaccounts/summary',
          altText: 'login'
        }
      ]
    },
    {
      name: 'PrimaryNav',
      title: 'PrimaryNav',
      isActive: 'true',
      children: [
        {
          name: '01-MyAccounts',
          title: 'MY ACCOUNTS',
          shortTitle: 'MY ACCOUNTS',
          url: '/myaccounts/summary',
          altText: 'MY ACCOUNTS',
          isActive: 'true',
          children: ''
        },
        {
          name: '02-MFL',
          title: 'MY FINANCIAL LIFE',
          shortTitle: 'MY FINANCIAL LIFE',
          url: 'https://www3.qa.coint.prudential.com/mfl',
          altText: 'MY FINANCIAL LIFE',
          isActive: 'false',
          children: ''
        },
        {
          name: 'Service-Center-BU3',
          title: 'MY SERVICE CENTER',
          shortTitle: 'MY SERVICE CENTER',
          url: 'https://www3.qa.coint.prudential.com/my-service-center/',
          altText: 'MyServiceCenter',
          isActive: 'false',
          children: ''
        }
      ]
    },
    {
      name: 'TopNav',
      title: 'TopNav',
      children: [
        {
          name: '01-ContactUs',
          title: 'Help',
          shortTitle: 'Help',
          url: 'https://www3.qa.coint.prudential.com/my-service-center/faqs',
          altText: 'Help',
          isActive: 'true',
          children: ''
        }
      ]
    }
  ],
  navigation_ite: [
    {
      name: 'AppSettingsNav',
      title: 'AppSettingsNav',
      children: [
        {
          name: 'Alerts-01',
          title: 'Alerts',
          shortTitle: 'Alerts',
          url: 'https://www.ite.coint.prudential.com/my-service-center/alerts'
        },
        {
          name: 'accountLinks',
          title: 'accountLinks',
          children: [
            {
              name: 'myAccount',
              title: 'My Profile',
              shortTitle: 'My Profile',
              url: '/mypru/myprofile#/',
              altText: 'Account'
            }
          ]
        },
        {
          name: 'homeurl',
          title: 'homeurl',
          shortTitle: 'homeurl',
          url: '/myaccounts/summary',
          altText: 'login'
        }
      ]
    },
    {
      name: 'PrimaryNav',
      title: 'PrimaryNav',
      children: [
        {
          name: '01-MyAccounts',
          title: 'MY ACCOUNTS',
          shortTitle: 'MY ACCOUNTS',
          url: '/myaccounts/summary',
          altText: 'MY ACCOUNTS',
          isActive: 'true',
          children: ''
        },
        {
          name: '02-MFL',
          title: 'MY FINANCIAL LIFE',
          shortTitle: 'MY FINANCIAL LIFE',
          url: 'https://www.ite.coint.prudential.com/mfl',
          altText: 'MY FINANCIAL LIFE',
          isActive: 'false',
          children: ''
        },
        {
          name: 'SERVICE CENTER',
          title: 'MY SERVICE CENTER',
          shortTitle: 'MY SERVICE CENTER',
          url: 'https://www.ite.coint.prudential.com/my-service-center/',
          altText: 'MyServiceCenter',
          isActive: 'false',
          children: ''
        }
      ]
    },
    {
      name: 'TopNav',
      title: 'TopNav',
      children: [
        {
          name: '01-ContactUs',
          title: 'Help',
          shortTitle: 'Help',
          url: 'https://www.ite.coint.prudential.com/my-service-center/faqs',
          altText: 'Help',
          isActive: 'true',
          children: ''
        }
      ]
    }
  ],
  navigation_stage: [
    {
      name: 'AppSettingsNav',
      title: 'AppSettingsNav',
      children: [
        {
          name: 'Alerts-01',
          title: 'Alerts',
          shortTitle: 'Alerts',
          url: 'https://www3.stage.coint.prudential.com/my-service-center/alerts',
          altText: 'Alerts'
        },
        {
          name: 'accountLinks',
          title: 'accountLinks',
          children: [
            {
              name: 'myAccount',
              title: 'My Profile',
              shortTitle: 'My Profile',
              // url: "/wps/myportal/dashboard/my-profile/",
              url: '/mypru/myprofile#/',
              altText: 'Account'
            }
          ]
        },
        {
          name: 'homeurl',
          title: 'homeurl',
          shortTitle: 'homeurl',
          url: '/myaccounts/summary',
          altText: 'login'
        }
      ]
    },
    {
      name: 'PrimaryNav',
      title: 'PrimaryNav',
      children: [
        {
          name: '01-MyAccounts',
          title: 'MY ACCOUNTS',
          shortTitle: 'MY ACCOUNTS',
          url: '/myaccounts/summary',
          altText: 'MY ACCOUNTS',
          isActive: 'true',
          children: ''
        },
        {
          name: '02-MFL',
          title: 'MY FINANCIAL LIFE',
          shortTitle: 'MY FINANCIAL LIFE',
          url: 'https://www3.stage.coint.prudential.com/mfl',
          altText: 'MY FINANCIAL LIFE',
          isActive: 'false',
          children: ''
          //  [
          //    {
          //      name: "01-Home",
          //      title: "Home",
          //      shortTitle: "Home",
          //      url: "/",
          //      altText: "Home",
          //      isActive: "false",
          //      isRouter: "true"
          //    },
          //    {
          //      name: "02-MyInterests",
          //      title: "My Interests",
          //      shortTitle: "My Interests",
          //      url: "/myinterests",
          //      altText: "My Interests",
          //      isActive: "false",
          //      isRouter: "true"
          //    },
          //    {
          //      name: "03-Tools",
          //      title: "Tools",
          //      shortTitle: "Tools",
          //      url: "/financial-wellness/tools",
          //      altText: "Tools",
          //      isActive: "false",
          //      isRouter: "false"
          //    },
          //    {
          //      name: "04-Financial Wellness",
          //      title: "Financial Wellness",
          //      shortTitle: "Financial Wellness",
          //      url: "/financial-wellness/",
          //      altText: "Financial Wellness",
          //      isActive: "false",
          //      isRouter: "false"
          //    }
          //  ]
        },
        {
          name: 'SERVICE CENTER',
          title: 'MY SERVICE CENTER',
          shortTitle: 'MY SERVICE CENTER',
          url: 'https://www3.stage.coint.prudential.com/my-service-center/',
          altText: 'MyServiceCenter',
          isActive: 'false',
          children: ''
        }
      ]
    },
    {
      name: 'TopNav',
      title: 'TopNav',
      children: [
        {
          name: '01-ContactUs',
          title: 'Help',
          shortTitle: 'Help',
          url:
            'https://www3.stage.coint.prudential.com/my-service-center/faqs',
          altText: 'Help',
          isActive: 'true',
          children: ''
        }
      ]
    }
  ],
  navigation_prod: [
    {
      name: 'AppSettingsNav',
      title: 'AppSettingsNav',
      children: [
        {
          name: 'Alerts-01',
          title: 'Alerts',
          shortTitle: 'Alerts',
          url: 'https://www.prudential.com/my-service-center/alerts'
        },
        {
          name: 'accountLinks',
          title: 'accountLinks',
          children: [
            {
              name: 'myAccount',
              title: 'My Profile',
              shortTitle: 'My Profile',
              url: '/wps/myportal/dashboard/my-profile/',
              altText: 'Account'
            }
          ]
        },
        {
          name: 'homeurl',
          title: 'homeurl',
          shortTitle: 'homeurl',
          url: '/myaccounts/summary',
          altText: 'login'
        }
      ]
    },
    {
      name: 'PrimaryNav',
      title: 'PrimaryNav',
      children: [
        {
          name: '01-MyAccounts',
          title: 'MY ACCOUNTS',
          shortTitle: 'MY ACCOUNTS',
          url: '/myaccounts/summary',
          altText: 'MY ACCOUNTS',
          isActive: 'true',
          children: ''
        },
        {
          name: '02-MFL',
          title: 'MY FINANCIAL LIFE',
          shortTitle: 'MY FINANCIAL LIFE',
          url: 'https://www.prudential.com/mfl',
          altText: 'MY FINANCIAL LIFE',
          isActive: 'false',
          children: ''
        },
        {
          name: 'SERVICE CENTER',
          title: 'MY SERVICE CENTER',
          shortTitle: 'MY SERVICE CENTER',
          url: 'https://www.prudential.com/my-service-center',
          altText: 'MyServiceCenter',
          isActive: 'false',
          children: ''
        }
      ]
    },
    {
      name: 'TopNav',
      title: 'TopNav',
      children: [
        {
          name: '01-ContactUs',
          title: 'Help',
          shortTitle: 'Help',
          url: 'https://www.prudential.com/my-service-center/faqs',
          altText: 'Help',
          isActive: 'true',
          children: ''
        }
      ]
    }
  ],
  timeoutconfig: {
    title: 'Your Session is About to Expire!',
    message: 'Keep Session alive?',
    logoutButton: 'Logout',
    keepAliveButton: 'Stay Connected',
    keepAliveUrl: [],
    keepAlivePinged: false,
    ajaxType: 'GET',
    ajaxData: '',
    refreshOnTimeOut: false,
    redirUrl: '',
    logoutUrl: '/log-out',
    warnAfter: 480000,
    redirAfter: 540000,
    // warnAfter: 120000, //test
    // redirAfter: 180000,//test
    warnOnly: false,
    keepAliveInterval: 5000,
    keepAliveVal: true,
    ignoreUserActivity: true,
    onWarn: false,
    onRedir: false,
    countdownMessage: '',
    countdownBar: true,
    countdownSmart: true,
    hideModalOnAction: false,
    logoutFunction: false,
    countdown: {},
    countdownWidth: 100,
    countdownText: ''
  },
  overlay: [
    {
      title: 'Slide 1',
      seq: '1',
      overlayImage:
        '/wps/wcm/myconnect/86d44bd9-3d01-410b-bf30-f5dcfa9dc5d0/Welcome_Image.jpg?MOD=AJPERES&CACHEID=ROOTWORKSPACE-86d44bd9-3d01-410b-bf30-f5dcfa9dc5d0-mh.-q1x',
      shortDescription: 'Slide',
      helpoverlay_description:
        '<div class="text-center"><p class="h2 slideTitle" tabindex="-1">Welcome</p><p><img src="https://cdn.pficdn.com/myaccounts/18.47.174/images/Welcome_Image.jpg" class="img-responsive" alt=""/></p><p>Your new account experience was built with one goal: helping you achieve yours. Let us explore what you can do.</p></div>',
      description: 'Slide one content',
      styleClass: 'item active',
      liActive: 'active',
      idx: '0'
    },
    {
      title: 'Slide2',
      seq: '2',
      overlayImage:
        '/wps/wcm/myconnect/5f228a57-7f15-489e-86fd-a81731eeca80/SeetheBigPiture_Image.gif?MOD=AJPERES&CACHEID=ROOTWORKSPACE-5f228a57-7f15-489e-86fd-a81731eeca80-mh.-q1x',
      shortDescription: 'Slide2',
      helpoverlay_description:
        '<div class="text-center"><p><img src="https://cdn.pficdn.com/myaccounts/18.47.174/images/SeetheBigPiture_Image.gif" class="img-responsive" alt="" /></p><p class="h2 slideTitle" tabindex="-1">See the Big Picture</p><p>Your Prudential account is now shown alongside other opportunities spanning assets, income and insurance.</p></div>',
      description: 'Slide2 content',
      styleClass: 'item',
      liActive: '',
      idx: '1'
    },
    {
      title: 'Slide3',
      seq: '3',
      overlayImage:
        '/wps/wcm/myconnect/49c1942d-4b81-4ed0-9e2f-bb433d9eca94/Maximaze_Experience_Image.jpg?MOD=AJPERES&CACHEID=ROOTWORKSPACE-49c1942d-4b81-4ed0-9e2f-bb433d9eca94-mh.-q1x',
      shortDescription: 'Slide3',
      helpoverlay_description:
        '<div class="text-center"><p><img src="https://cdn.pficdn.com/myaccounts/18.47.174/images/Maximaze_Experience_Image.jpg" class="img-responsive" alt="" /></p><p class="h2 slideTitle" tabindex="-1">Maximize Your Experience</p><p>Easy access to your profile page lets you manage preferences: security settings, contact information and more.</p></div>',
      description: 'Slide3 content',
      styleClass: 'item',
      liActive: '',
      idx: '2'
    },
    {
      title: 'Slide4',
      seq: '4',
      overlayImage:
        '/wps/wcm/myconnect/04db834b-6181-43c3-8d79-d5da0879ed81/Go_Deep_Image.jpg?MOD=AJPERES&CACHEID=ROOTWORKSPACE-04db834b-6181-43c3-8d79-d5da0879ed81-mh.-q1x',
      shortDescription: 'Slide4',
      helpoverlay_description:
        '<div class="text-center"><p><img src="https://cdn.pficdn.com/myaccounts/18.47.174/images/Go_Deep_Image.jpg" class="img-responsive" alt=""/></p><p class="h2 slideTitle" tabindex="-1">Go Deep</p><p>Exploring the details of an individual account - and making any necessary tweaks - is as quick as a single click.</p></div>',
      description: 'Slide4 content',
      styleClass: 'item',
      liActive: '',
      idx: '3'
    },
    {
      title: 'Slide5',
      seq: '5',
      overlayImage:
        '/wps/wcm/myconnect/7bb73108-f4bb-4d99-97b8-9264e59ee772/Get_Smarter_Image.jpg?MOD=AJPERES&CACHEID=ROOTWORKSPACE-7bb73108-f4bb-4d99-97b8-9264e59ee772-mh.-q1x',
      shortDescription: 'Slide5',
      helpoverlay_description:
        '<div class="text-center"><p><img src="https://cdn.pficdn.com/myaccounts/18.47.174/images/Get_Smarter_Image.jpg" class="img-responsive" alt=""/></p><p class="h2 slideTitle" tabindex="-1">Get Smarter</p><p>The My Financial Life experience gives you articles, videos and tools for the topics you care about most.</p></div>',
      description: 'Slide5 content',
      styleClass: 'item',
      liActive: '',
      idx: '4'
    }
  ],
  fallBackContent: {
    contents: [
      {
        title: 'Assets',
        articleLink:
          '/financial-wellness/retirement-planning/target-date-vs-managed-accounts/',
        ctaText: 'Learn More',
        shortDescription:
          'Target-Date Funds vs. Managed Accounts: Which Is Right for You?'
      },
      {
        title: 'Retirement Planning',
        articleLink:
          '/financial-wellness/retirement-planning/raiding-retirement-accounts/',
        ctaText: 'Learn More',
        shortDescription: "3 Reasons You Shouldn't Raid Your Retirement Account"
      },
      {
        title: 'Preparing & Protecting',
        articleLink:
          '/financial-wellness/preparing-protecting/video-virtually-better-benefits/',
        ctaText: 'Learn More',
        shortDescription: 'Video: Virtually Better Benefits'
      },
      {
        thumbnailImg: '/myauth-static-assets/19.10.14/images/tina-tumbnail.jpg',
        title: "3 Vital To-Do's As You Approach Retirement",
        articleLink: '/financial-wellness/albums/album-ret/',
        imgDetail2AltTxt: '',
        ctaText: 'Dig In',
        shortDescription:
          'Get friendly retirement tips for managing costs, creating income and maxing your savings..'
      },
      {
        thumbnailImg:
          '/wps/wcm/connect/0955b8ba-5d8c-46fd-8f5e-cb9068dd3631/mfl-hook-526x292.jpg?MOD=AJPERES&CACHEID=ROOTWORKSPACE-0955b8ba-5d8c-46fd-8f5e-cb9068dd3631-m6vxVHq',
        title: 'My Financial Life',
        articleLink: '/mfl',
        imgDetail2AltTxt: '',
        ctaText: 'Check It Out',
        shortDescription:
          'My Financial Life offers financial guidance, in easy-to-understand and even interactive formats.'
      }
    ],
    code: null,
    message: null,
    totalMatches: 6
  }
};
